import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { useIsOptionRichText } from '../Common/useIsOptionRichText';

import s from './MultiChoiceAnswerItem.scss';
import { IAnswerOption } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';

export interface IMultiChoiceAnswerItemProps {
    option: IAnswerOption;
    onSelectOption: () => void;
}

export const MultiChoiceAnswerItem = React.memo(
	({ option, onSelectOption }: IMultiChoiceAnswerItemProps): JSX.Element => {
		useStyles(s);
		const isOptionRichText = useIsOptionRichText(option.text);

		return option ? (
			<div
				className={`sl-multi-choice-item ${option.status}`}
				onClick={onSelectOption}
				sl-test-data="cmpMultiChoiceAnswerItem"
			>
				<label className="sl-multi-choice-item__checkbox">
					<span className="sl-multi-choice-item__checkbox__box">
						<svg width="14px" height="14px" viewBox="0 0 14 14">
							<polyline points="1.5 6 4.5 9 10.5 1" />
						</svg>
					</span>
					{isOptionRichText ? (
						<span
							className="sl-multi-choice-item__checkbox__label"
							dangerouslySetInnerHTML={{
								__html: option.text,
							}}
						/>
					) : (
						<span className="sl-multi-choice-item__checkbox__label">
							{option.text}
						</span>
					)}
				</label>
			</div>
		) : null;
	},
);
